/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Banner from "../../../components/passenger/home/Banner";
import DownloadApp from "../../../components/passenger/home/DownloadApp";
import Experience from "../../../components/passenger/home/Experience";
import Order from "../../../components/passenger/home/Order";
import Places from "../../../components/passenger/home/Places";
import Services from "../../../components/passenger/home/Services";
import Social from "../../../components/passenger/home/Social";
import Header from "../../../components/common/layout/Header";
import { useEffect, useState } from "react";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useDispatch, useSelector } from "react-redux";
import { dataActions } from "../../../shared/store/data-Slice";
import GovImages from "../../../components/passenger/home/GovImages";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Canonical from "../../../components/common/layout/Canonical";
import { sitemap } from "../../../shared/utils/sitemap";
import AnnouncementBanner from "../../../components/common/layout/AnnouncementBanner";
import NCMCPopup from "../../../components/passenger/home/NCMCPopup";

const Home = ({ popup }: any) => {
  const lang: string = useSelector((state: any) => state.ui.lang);
  const [line, setLine] = useState<any>(null)
  const [announcementBannerOpen, setAnnouncementBannerOpen] = useState<any>(true);
  const [ncmcOpen, setNcmcOpen] = useState<any>(true);
  const { t } = useTranslation('common');
  const dispatch = useDispatch();

  const getLine = async () => {
    try {
      const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.line_list}`);

      if (res && res?.status === 200) {
        res?.data?.length > 0 && setLine(res?.data?.[0])
      }
    } catch (error) {
      console.error("error while feching line list", error);
    }
  };

  useEffect(() => {
    !!lang && getLine();
  }, [lang])

  useEffect(() => {
    popup === "fare-recharge" ? dispatch(dataActions.setFareOpen(true)) : dispatch(dataActions.setFareOpen(false))
    popup === "feedback" ? dispatch(dataActions.setFeedbackOpen(true)) : dispatch(dataActions.setFeedbackOpen(false))
    popup === "report-lost-item" ? dispatch(dataActions.setReportItemOpen(true)) : dispatch(dataActions.setReportItemOpen(false))
    sitemap()
  }, [popup])

  useEffect(() => {
    if (ncmcOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [ncmcOpen]);

  return (
    <>
      {/* {announcementBannerOpen && <AnnouncementBanner announcementBannerOpen={announcementBannerOpen} setAnnouncementBannerOpen={setAnnouncementBannerOpen} />} */}
      {ncmcOpen && <NCMCPopup ncmcOpen={ncmcOpen} setNcmcOpen={setNcmcOpen} />}
      <Canonical />
      <>
        {popup === "fare-recharge" ?
          <Helmet>
            <title>{t("seo_friendly.fare.title")}</title>
            <meta name="description" content={t("seo_friendly.fare.desc")} />
          </Helmet> :
          popup === "report-lost-item" ?
            <Helmet>
              <title>{t("seo_friendly.lost_found.title")}</title>
              <meta name="description" content={t("seo_friendly.lost_found.desc")} />
            </Helmet>
            : <Helmet>
              <title>{t("seo_friendly.passenger_home.title")}</title>
              <meta name="description" content={t("seo_friendly.passenger_home.desc")} />
            </Helmet>}
      </>
      <div className="bg-[#F8F8F8] dark:bg-bgDark w-full h-full">
        <Header type="passenger" />
        <Banner />
      </div>
      <div id="home" className="dark:bg-bgDarkDull bg-white">
        <Services line={line} />
        <Experience />
        <Order line={line} />
        <Places />
        <Social />
        <DownloadApp />
        <GovImages />
      </div>
    </>
  );
};

export default Home;